import React, { useEffect, useState } from 'react';
import cn from "classnames";
import ReactTooltip from "react-tooltip";
import {TableHeader} from "./TableHeader";
import {isEmpty} from "lodash";
import {ItemRow} from "./ItemRow";
import Loader from "../../../components/utils/Loader";
import Select from "react-select";
import {styles} from "../../../containers/goods/styles";
import {useDispatch, useSelector} from "react-redux";
import {suppliersLoadingSelector, suppliersSelector} from "../../../selectors/forms";
import { fetchInvoices, fetchSuppliers, setInvoicesFilters, setInvoicesPaging } from '../../../action';
import ReactPaginate from 'react-paginate';
import { fetchFilials } from '../../../action/handbook';
import PointsSelect from '../../../components/utils/PointsSelect';
import ResultRow from './ResultRow';
import DateSelect from '../../../components/utils/DateSelect';

const paymentsOptions = [
    { value: "cash", label: "Наличные" },
    { value: "noncash", label: "Расчетный счет"},
];

const payedOptions = [
    { value: "paymented", label: "Оплачено" },
    { value: "none", label: "Не оплачено" },
]

const InvoiceList = () => {
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointsLoading = useSelector(state => state.loaders.filials);
    const suppliers = useSelector(suppliersSelector);
    const UImobile = useSelector(state => state.UImobile);
    const filters = useSelector(state => state.invoiceforms.filters);
    const paging = useSelector(state => state.invoiceforms.paging);
    const count = useSelector(state => state.invoiceforms.count);
    const invoiceForms = useSelector(state => state.invoiceforms.list)
    const loadingInvoice = useSelector(state => state.loaders.invoices);

    const suppliersLoading = useSelector(suppliersLoadingSelector);
    const loading = loadingInvoice || suppliersLoading || pointsLoading;

    const [currentPage, setCurrentPage] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(suppliers)) dispatch(fetchSuppliers(false, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => onSearch(), []);

    const onSearch = () => {
        dispatch(setInvoicesPaging({ ...paging, start: 0 }));
        setCurrentPage(0);
        dispatch(fetchInvoices());
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.startDate = e.min;
            updated.endDate = e.max;
            dispatch(setInvoicesFilters(updated));
            onSearch();
        }
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters };

        let value = null;
        if (data) {
            if (data.value) {
                value = data.value;
            } else {
                value = data;
            }
        }
        updated[field] = value;

        if (field === 'payed' && (!value || value === 'none')) updated.payment = null;

        if(value === null) updated[field] = null;
        dispatch(setInvoicesFilters(updated));
        onSearch();
    }

    const supplierOptions = suppliers.map(supplier => ({
        value: supplier.id,
        label: supplier.name,
    }));
    
    useEffect(() => {        
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        let nextStart =  data.selected * paging.limit;
        const updatedPaging = {...paging, start: nextStart};
        dispatch(setInvoicesPaging(updatedPaging));
        dispatch(fetchInvoices());
    };

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        setCurrentPage(0);
        dispatch(setInvoicesPaging(updatedPaging));
        dispatch(fetchInvoices());
    }

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    const renderPagination = () => {
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    const getSelectedDate = () => {
        if (!filters) return;
        if (filters.startDate && filters.endDate) return { value: { min: filters.startDate, max: filters.endDate } };
        if (filters.startDate) return { value: { min: filters.startDate } };
        if (filters.endDate) return { value: { max: filters.endDate } };
        return;
    }

    const selected = getSelectedDate();

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{padding: 0}}>
                <div className="kt-portlet__body">
                    <div className='kt-form kt-form--label-right kt-margin-b-10 d-flex' style={{ gap: '10px' }}>
                        {!isMobile ? (
                            <>
                                <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                                <div className="kt-subheader__group" id="kt_subheader_search">
                                <span className="kt-subheader__desc" id="kt_subheader_total">
                                    <div style={{ width: 200 }}>
                                        <DateSelect
                                            isDisabled={loading}
                                            isLoading={loading}
                                            optionsDate={{
                                                tommorow: true,
                                                period: true,
                                                prevWeek: true,
                                                prevMonth: true,
                                            }}
                                            selected={selected}
                                            limit={{ 
                                                field: 'days',
                                                value: 31
                                            }}
                                            width={200}
                                            onChange={onChangeDateSelect}
                                        />
                                    </div>
                                </span>
                                </div>
                                <PointsSelect width={200} placeholder='Все филиалы' values={filters.points} setData={setFilters('points')}/>
                                <div style={{ width: 175 }}>
                                    <Select
                                        options={supplierOptions}
                                        placeholder="Поставщик"
                                        isClearable={true}
                                        onChange={setFilters('supplier')}
                                        isLoading={suppliersLoading}
                                    />
                                </div>
                                <div style={{ width: 175 }}>
                                    <Select
                                        options={payedOptions}
                                        placeholder="Оплата"
                                        isClearable={true}
                                        onChange={setFilters('payed')}
                                    />
                                </div>
                                {filters.payed && filters.payed !== 'none' && <div style={{ width: 175 }}>
                                    <Select
                                        options={paymentsOptions}
                                        placeholder="Тип оплаты"
                                        isClearable={true}
                                        onChange={setFilters('payment')}
                                    />
                                </div>}
                            </>
                        ) : UImobile.openFilters && (
                            <div key={window.innerWidth}>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Филиалы</label>
                                    <PointsSelect width={200} placeholder='Все филиалы' values={filters.points} setData={setFilters('points')}/>
                                </div>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Поставщик</label>
                                    <Select
                                        options={supplierOptions}
                                        placeholder="Поставщик"
                                        isClearable={true}
                                        onChange={setFilters('supplier')}
                                        isLoading={suppliersLoading}
                                    />
                                </div>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Оплата</label>
                                    <div style={{ width: 175 }}>
                                        <Select
                                            options={payedOptions}
                                            placeholder="Оплата"
                                            isClearable={true}
                                            onChange={setFilters('payed')}
                                        />
                                    </div>
                                    {filters.payed && filters.payed !== 'none' && <div style={{ width: 175 }}>
                                    <Select
                                        options={paymentsOptions}
                                        placeholder="Тип оплаты"
                                        isClearable={true}
                                        onChange={setFilters('payment')}
                                    />
                                </div>}
                                </div>
                                <div className="mb-3 mobile-filter-item">
                                    <div style={{ width: 200 }}>
                                        <label className="d-block">Даты</label>
                                        <DateSelect
                                            isDisabled={loading}
                                            isLoading={loading}
                                            optionsDate={{
                                                tommorow: true,
                                                period: true,
                                                prevWeek: true,
                                                prevMonth: true,
                                            }}
                                            limit={{ 
                                                field: 'days',
                                                value: 31
                                            }}
                                            width={200}
                                            onChange={onChangeDateSelect}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <div
                        style={{position: 'relative', marginBottom: 0}}
                        className={cn(
                            'kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded',
                            {'kt-datatable--error': !loading && isEmpty(invoiceForms)}
                        )}
                    >
                        {loading && (
                            <div style={styles.tableLoading}>
                                <Loader text="Загружаем накладные..."/>
                            </div>
                        )}
                        <table className="kt-datatable__table" style={window.innerWidth > 730 ? { minHeight: '700px' } : {}}>
                            {window.innerWidth > 1024 && <TableHeader UImobile={UImobile}/>}
                            <tbody className="kt-datatable__body">
                            {
                                loading ? null : isEmpty(invoiceForms) ? (
                                        <tr>
                                            <td colSpan={4}>
                                              <span className="kt-datatable--error">
                                                  Накладных нет
                                              </span>
                                            </td>
                                        </tr>
                                    )
                                    : (
                                        <>
                                        {invoiceForms.map((item) => {
                                            let point = item.point;
                                            if (point && !point.id) point = points.find((el) => el.id === point);
                                            if (point && point.id && (!point.city || !point.city.id)) point = points.find((el) => el.id === point.id);
                                            item.point = point;
                                            if (item.supplier && !item.supplier.id) item.supplier = suppliers.find((supplier) => supplier.id === item.supplier);
                                            return <ItemRow key={item.id} item={item}/>
                                        })}
                                        <ResultRow items={invoiceForms} />
                                        </>
                                        
                                    )
                            }
                            </tbody>
                        </table>
                        {renderPagination()}
                    </div>
                </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
};

export default InvoiceList;
